import { styled, FormControl } from "@avenue-8/ui-2";

export const FormItem = styled(FormControl)`
  &:last-of-type {
    margin-bottom: ${({ margin }) => (margin === "normal" ? "0" : "1rem")};
  }
`;
